<template>
	<AppFooter class="display-flex flex-space-between--center px-12 py-4">
		<div class="dummy-div" />
		<span class="flex-centerize">
			<slot />
		</span>
		<div class="tertiary-link-style ml-8" @click="$emit('cancel')">Cancel</div>
	</AppFooter>
</template>

<script>
export default {
	name: 'AppFooterWrapper',
};
</script>

<style scoped lang="scss">
.footer {
	box-shadow: 9px 3px 14px 0 rgb(49 70 111 / 44%) !important;
}
</style>
